var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-wrp"},[_c('canvas',{ref:"qrCode",staticClass:"w-full",class:{
      'mr-3': _vm.hasMarginRight,
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }